<template>
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M5.16545 12.9341H10.9147V11.8186H5.16545V12.9341ZM5.16545 9.84499H10.9147V8.72946H5.16545V9.84499ZM3.66443 15.8088C3.27786 15.8088 2.95228 15.6754 2.6877 15.4087C2.42312 15.1419 2.29083 14.8154 2.29083 14.4291V1.57101C2.29083 1.18472 2.42419 0.858219 2.69092 0.591494C2.95764 0.324769 3.28415 0.191406 3.67044 0.191406H10.314L13.7893 3.66669V14.4291C13.7893 14.8154 13.6559 15.1419 13.389 15.4087C13.1221 15.6754 12.7954 15.8088 12.4089 15.8088H3.66443ZM9.49884 4.48189V1.30693H3.67044C3.60436 1.30693 3.54387 1.33446 3.48895 1.38952C3.43389 1.44444 3.40636 1.50494 3.40636 1.57101V14.4291C3.40636 14.4952 3.43389 14.5557 3.48895 14.6106C3.54387 14.6657 3.60436 14.6932 3.67044 14.6932H12.4097C12.4758 14.6932 12.5363 14.6657 12.5912 14.6106C12.6463 14.5557 12.6738 14.4952 12.6738 14.4291V4.48189H9.49884Z"
            fill="#696969" />
        </svg>
        <h4 class="nxp-review-title">Currículo</h4>
      </div>

      <button class="nxp-review-title-action" type="button" @click="navigateToSelectedStep">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2 mb-4" />

    <div v-if="show()" class="nxp-file-input-success items-center cursor-pointer" @click="handleVisualizeCurriculumn">
      <div class="divider" :style="{background: color}"></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <g clip-path="url(#clip0_917_23314)">
          <path
            d="M7.51066 12.7765L12.0636 8.22334L11.198 7.35782L7.51901 11.0366L5.72203 9.21766L4.82596 10.0915L7.51066 12.7765ZM3.92878 16.0005C3.53273 16.0005 3.19916 15.8639 2.92809 15.5906C2.65702 15.3173 2.52148 14.9828 2.52148 14.5871V1.41345C2.52148 1.01769 2.65812 0.683173 2.93139 0.409904C3.20466 0.136635 3.53917 0 3.93494 0H10.7415L14.3021 3.56056V14.5871C14.3021 14.9828 14.1654 15.3173 13.892 15.5906C13.6186 15.8639 13.2838 16.0005 12.8878 16.0005H3.92878ZM9.90634 4.39575V1.14289H3.93494C3.86724 1.14289 3.80526 1.1711 3.749 1.22751C3.69258 1.28378 3.66438 1.34576 3.66438 1.41345V14.5871C3.66438 14.6548 3.69258 14.7167 3.749 14.773C3.80526 14.8294 3.86724 14.8576 3.93494 14.8576H12.8886C12.9563 14.8576 13.0183 14.8294 13.0746 14.773C13.131 14.7167 13.1592 14.6548 13.1592 14.5871V4.39575H9.90634Z"
            :fill="color" />
        </g>
        <defs>
          <clipPath id="clip0_917_23314">
            <rect width="16" height="16" fill="white" transform="translate(0.412109)" />
          </clipPath>
        </defs>
      </svg>
      <p>{{ basicInfo.curriculum_url ? basicInfo.curriculum_url.split('/').pop().slice(0, 14) + '.pdf' : null }}</p>
      <div class="w-4" style="height: 38px;"></div>
    </div>

    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Seu currículo está faltando! <br />Adicione para destacar suas qualificações
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="navigateToSelectedStep">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar Currículo
      </button>
    </div>
  </div>
</template>

<script>
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    notFilled: {
      type: Boolean,
      default: false,
    },
    cv_url: '',
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),

    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
  },

  methods: {
    show() {
      return (
        this.basicInfo.curriculum_url !== "" &&
        this.basicInfo.curriculum_url !== null &&
        this.basicInfo.curriculum_url !== undefined
      );
    },

    handleVisualizeCurriculumn() {
      window.open(`${this.basicInfo.curriculum_url}`, "_blank");
    },

    navigateToSelectedStep() {
      this.updateCurrentStep({ order: 0 });
      this.$router.push({ name: "step-basic-info" });
    },

    ...mapActions("step", ["updateCurrentStep"]),
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss">
.curriculo__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}
</style>
